(function () {
  var threshold = 10;
  var header = document.querySelector('.section-header');

  // Header only turns solid once it has reached the top of the viewport,
  // i.e. after any announcement bar above it has scrolled out of view.
  function update() {
    var stuck = !header || header.getBoundingClientRect().top <= 1;
    document.body.classList.toggle('header-scrolled', window.scrollY > threshold && stuck);
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();
